export default __webpack_public_path__ + "static/media/highlight-img-blue.22f67cbc.svg";